export default __webpack_public_path__ + "static/media/480_business04-nl-mobile.7483ef85.png";